import React, { useState } from "react";
import { Grid, Typography, CircularProgress } from "@material-ui/core";
import moment from "moment";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import Pagination from "@material-ui/lab/Pagination";

import { Card, CardContent, CardActions } from "../../components/Card";
import Table from "../../components/Table";
import Button from "../../components/Button";
import { TextInput } from "../../components/Form";
import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";
import { identity } from "../../components/utils";

const GET_SECRETS = gql`
  query secrets(
    $searchTerm: String
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    secrets(
      searchTerm: $searchTerm
      latest: $latest
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        questioner {
          id
          fullName
        }
        title
        createdAt
      }
    }
  }
`;

const DELETE_SECRET = gql`
  mutation deleteSecret($id: Int!) {
    deleteSecret(id: $id)
  }
`;

export default function SaleSecretTable({ onChangeSelect = () => {} }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const Alert = useAlert();
  const { data, refetch, loading } = useQuery(GET_SECRETS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      searchTerm,
      latest: true,
      pageSize: 10,
      page,
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  const [deleteSecret, { loading: deleteSecretLoading }] = useMutation(
    DELETE_SECRET,
    {
      onCompleted({ deleteSecret }) {
        if (deleteSecret) {
          return Alert.alert("", "刪除成功！", [
            {
              text: "確定",
              onPress: refetch,
              type: "ok",
            },
          ]);
        } else {
          return Alert.alert("", "刪除失敗！", [
            {
              text: "確定",
              type: "ok",
            },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={deleteSecretLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item>
              <TextInput
                placeholder="輸入關鍵字"
                value={searchTerm}
                onChange={(v) => {
                  setSearchTerm(v);
                }}
              />
            </Grid>
          </Grid>
          <Table
            data={data?.secrets.contents}
            tableWidth={2}
            header={["問題", "提問者", "提問時間", "操作"]}
            columns={[
              (item) => item.title,
              (item) => item.questioner.fullName,
              (item) => moment(item.createdAt).format("yyyy-MM-DD"),
              (item) =>
                identity && (
                  <Button
                    color="primary"
                    variant="contained"
                    onPress={(event) => {
                      event.stopPropagation();
                      Alert.alert("", "確定要刪除？", [
                        {
                          text: "確定",
                          onPress: () =>
                            deleteSecret({ variables: { id: item.id } }),
                          type: "ok",
                        },
                        { text: "取消", type: "cancel" },
                      ]);
                    }}
                  >
                    刪除
                  </Button>
                ),
            ]}
            onPress={(item) => {
              onChangeSelect(item);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.secrets.pageCount
                  ? data.secrets.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
